// deps
import React from "react";

// internal deps
import { IPayLaterPaymentGroup, PayLaterGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { usePayLaterHandler } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UsePayLaterHandler";

interface PayLaterGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: IPayLaterPaymentGroup["paymentData"];
}

export function PayLaterGroupHandler(props: PayLaterGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const { paymentActions, user } = usePayLaterHandler(props);

    if (user == null) {
        return null;
    }
    return (
        <PayLaterGroup user={user} paymentActions={paymentActions} paymentData={props.paymentGroup} {...otherProps} />
    );
}
